import Raven from 'raven-js'

import CONSTANTS from '~/constants'

const isLocalDev = document.location.hostname.indexOf('localhost') >= 0
let scoutClient

// Config & ignored error info: https://arcpublishing.atlassian.net/wiki/spaces/EL/pages/316014595/Pharos+Sentry+integration
function pharos(toastr) {
  this.initSentryConnection = () => {
    if (!isLocalDev) {
      Raven.config(CONSTANTS.SENTRY_DSN, {
        release: process.env.COMPOSER_VERSION,
        ignoreUrls: [/localhost/],
        ignoreErrors: [
          'Failed to fetch',
          'ResizeObserver loop limit exceeded',
          'Cross-origin redirection',
        ],
      }).install()
      Raven.setUserContext({
        email: window.localStorage.getItem('arc.email'),
        id: window.localStorage.getItem('arc.username'),
      })
      Raven.setTagsContext({
        organization: window.localStorage.getItem('arc.organization'),
      })
      Raven.setExtraContext({
        environment: window.localStorage.getItem('arc.environment'),
        authority: window.localStorage.getItem('arc.authority'),
        groups: window.localStorage.getItem('arc.groups'),
      })
    }
  }

  this.sendExceptionToSentry = (e, message) => {
    if (!isLocalDev) {
      if (this.shouldLogErrorToSentry(e)) {
        Raven.captureException(e, {
          extra: {
            message: message,
          },
        })
      }
    }
  }

  this.sendErrorMessageToSentry = (errorData) => {
    if (!isLocalDev) {
      const errorMessage =
        errorData.statusText ||
        `${
          errorData.status || errorData.statusCode || 'Unknown'
        } status code error; no status text provided.`
      Raven.captureMessage(errorMessage, {
        level: 'error',
        extra: errorData,
      })
    }
  }

  this.sendTimeToDataDog = (key, value, tags, sampleRate) => {
    if (!isLocalDev) {
      scoutClient.sendTime(key, value, tags, sampleRate)
    }
  }

  this.isOnline = () => {
    return navigator.onLine
  }

  this.shouldLogErrorToSentry = (error) => {
    // Omit browser disconnection issues: Failed to fetch (Chrome) & NetworkError (Firefox)
    return (
      this.isOnline &&
      error.message &&
      !error.message.match(/(Failed to fetch|Network ?Error)/)
    )
  }
}

export default ['toastr', pharos]
